<template>
	<div class="card-edit viewer-card" v-if="!isViewerActive">
		<o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
		<div class="viewer-card-header">
			<nav class="navbar" role="bim-viewer-card" aria-label="bim-viewer-card">
				<div class="navbar-menu is-align-items-center">
					<div class="navbar-start">
						<i class="icon-productionorderOL has-text-black-bis"></i>
						<div class="is-divider-vertical my-0"></div>
						<div class="has-text-black-bis">
							<h6 class="is-size-6 sub-header has-text-weight-semibold mb-1 mt-1">ADD MODEL OBJECTS/OBJECT GROUPS TO
								ORDER</h6>
							<h6 class="is-size-6 has-text-weight-semibold has-text-grey">PRODUCTION ORDER: {{ order.name }}</h6>
						</div>
					</div>
				</div>
				<div class="navbar-end">
					<div class="is-divider-vertical  my-1"></div>
					<div class="navbar-item">
						<a :href="openBIMPLUS()" target="_blank" class="has-text-black-bis"><i class="icon-bimplus"></i></a>
					</div>
				</div>
			</nav>
		</div>
		<div class="card-basic p-3">
			<div class="column">
				<div class="columns">
					<div class="column">
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label ">
									Manufacton Project:
								</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3">{{ selectedProject?.name }}</span>
							</div>
						</div>
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label mr-8">
									Stage:
								</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3">Detailing</span>
							</div>
						</div>
					</div>
					<div class="column">
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label">BIMPLUS Model:</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3" v-if="!$_.isEmpty(modelName)">
									{{ modelName }}
								</span>
							</div>
						</div>
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label mr-4">Model Source:</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3">
									{{ isSDS2 ? 'SDS2' : 'Other' }}
								</span>
							</div>
						</div>
					</div>
					<div class="column">
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label">
									Object Grouping:
								</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3" v-if="!isSDS2">
									{{ objGrpVal }}
								</span>
								<div v-else>
									<mf-multi-select :modelValue="groupOrderBy" track-by="value" label="label" :multiple="false"
										:options="objectGroupingOpts" :allow-empty="false" :closeOnSelect="true"
										@update:modelValue="($event) => groupOrderBy = $event">
									</mf-multi-select>
								</div>
							</div>
						</div>
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label mr-4">
									Item Grouping:
								</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3" v-if="isSDS2">
									Manufacton Assemblies
								</span>
								<div v-else>
									<mf-multi-select :modelValue="groupItemBy" track-by="value" label="label" :multiple="false"
										:options="itemGroupingOpts" :allow-empty="false" :closeOnSelect="true"
										@update:modelValue="($event) => groupItemBy = $event">
									</mf-multi-select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="is-divider my-2"></div>
		<div class="edit-body table-container has-background-white pr-4">
			<mf-table ref="BIMPLUSItemTable" :tableProps="itemTableProps" :loadData="loadItemsData" :hideGutter="true"
				:isBimPlus="true" :apiMode="true" :key="rerenderMfTable" @cell-clicked="onCellClicked"
				@refreshTable="rerenderMfTable++" :rowData="order" :project="selectedProject" :isSDS2="isSDS2">
				<template #itemDelete="{ rowData, rowField }">
					<field-card-edit-action :rowData="rowData" :rowField="rowField" @cell-clicked="onDeleteClicked" />
				</template>
				<template #templateSelect="{ rowData, rowField }">
					<SelectOptions v-model="rowData.template" :showApplyAll="false"
						:options="templateOrders" :key="refreshTemplate"
						@update:modelValue="$event => applyTemplate(rowData, $event)">
					</SelectOptions>
				</template>
				<template #viewBIM="{ rowData }">
					<div class="is-clickable is-flex is-align-items-center is-justify-content-center" @click="isolateModel(rowData)">
						<i class="icon-show"></i>
					</div>
				</template>
				<template #notes="{ rowData }">
					<div @click="addDocs(rowData)" :disabled="false" class="is-clickable is-flex is-align-items-center is-justify-content-center">
						<i :class="rowData.files ? 'icon-attacheddocuments' : 'icon-attacheddocumentsOL'"></i>
					</div>
				</template>
			</mf-table>
		</div>
		<card-footer :showSave="true" @backToCardEditView="closeAddItemsView" @reload-page="reloadPage" :card="order"
			:projectId="projectId" :stage="'detailing'" :cardId="order._id" :saveCard="saveCard" :addItems="addItems"
			:type="$store.state.activeScreen" :itemObject="mfItems" :project="selectedProject" :createBOM="createBOM"
			:key="refreshDetail" :modelId= "modelId" :isSDS2="isSDS2" buttonPosition="right">

		</card-footer>
	</div>
  <Documents v-if="docsEdit"
		:isActive="docsEdit"
		:rowData="selectedRowData"
		modalHeader="Add Documents"
		:orderTitle="docsTitle"
		:isBIMPLUS="true"
		:orderDetails="order"
    @close="closeDocsModal">
	</Documents>
  <BimPlusViewerVue v-if="isViewerActive"
    :projectId="projectId"
    :addObjectsBySelection="enableAddObjectsBySelection"
    :isolateView="enableIsolateView"
		:modelId= "modelId"
		:orderName="order.name"
    :modelName="modelName"
    :guids="guidsList"
    :disableObjectProperties="disableObjectProperties"
    @addItemView="headerClick"
    @back="closeViewer"/>
</template>

<script>
import { computed, inject, onBeforeMount, reactive, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { find, get, isEmpty, round, isNumber, remove, toLower, cloneDeep, toUpper, uniq, startCase } from 'lodash';
import { ModalProgrammatic } from '@oruga-ui/oruga-next';

import Projects from '@/models/Projects';
import SupplyChain from '@/models/SupplyChain';
import ProductionManager from '@/models/ProductionManager';
import urls from '@/urls';
import { v4 as uuid } from 'uuid';
import bimplusViewer from '../views/bimplus/bimplusViewer';
import ProductionManagerMixin from './mixins/ProductionManagerMixin';
import Catalogs from '@/models/Catalogs';
import BimPlus from '@/models/BimPlus';

import addItemsFromBimplusCols from '@/components/table-cols/addItemsFromBimplusCols';
import TemplateSelect from '@/components/fields/TemplateSelect.vue';

import MfTable from '@/components/table-fields/MfTable.vue';
import Documents from '@/components/modals/TableDocuments.vue';
import BimPlusViewerVue from '@/views/bimplus/BimPlusViewer.vue';
import AddItemsByObjectGroup from '@/components/modals/AddItemsByObjectGroup.vue';
import CardFooter from '@/components/card-edit/CardFooter.vue';
import SelectOptions from '@/components/abstract/SelectOptions.vue';


export default {
	name: 'AddItemsFromBIMPLUSObject',
	props: {
		projectId: {
			type: String,
			default: '',
		},
		models: {
			type: Array,
			required: true
		},
	},
	components: {
		'mf-table': MfTable,
    'template-select': TemplateSelect,
		Documents,
		BimPlusViewerVue,
		'card-footer': CardFooter,
		SelectOptions,
	},
	setup(props, { emit }) {
		const route = useRoute();
		const store = useStore();
		const toast = useToast();
		const router = useRouter();
		const emitter = inject('emitter');
		const { addPMItem, saveCard } = ProductionManagerMixin();
		const BIMPLUSItemTable = ref(null);
		
		const itemGroupingOpts = [
			{ label: 'Individual Manufacton Items', value: 'group-Individual' },
			{ label: '(1) Manufacton Item', value: 'group-single' },
			{ label: 'Manufacton Assemblies', value: 'group-Assemblies' },
		];
		const objectGroupingOpts = [
			{ label: 'Name', value: 'name' },
			{ label: 'PieceMark', value: 'piecemark' },
			{ label: 'Member category', value: 'member category' },
			{ label: 'Member description', value: 'member description' },
			{ label: 'Member sequence', value: 'member sequence' },
			{ label: 'Package Number', value: 'package number' },
			{ label: 'Shop Sequence Number', value: 'shop sequence number' },
		]

		const state = reactive({
			selectedProject: {},
			isLoading: false,
			isSDS2: false,
			createBOM: false,
      docsEdit: false,
      isViewerActive: false,
      enableAddObjectsBySelection: true,
      enableIsolateView: false,
      disableObjectProperties: true,
			groupItemBy: itemGroupingOpts[0],
			groupOrderBy: objectGroupingOpts[0],
			itemTableProps: addItemsFromBimplusCols,
			rerenderMfTable: 0,
      docsTitle: null,
			order: {},
      elementData: [],
      groupedElement: {},
      selectedItems: [],
      mfItems: [],
      modelId: '',
      guidsList: [],
      selectedRowData: [],
      templateOrders: [],
      templateProject: {},
			identifierList: [],
			refreshDetail: 0,
		});

		const loadItemsData = async () => {
			if (isEmpty(state.mfItems)) return {};
			state.refreshDetail++;
			return { data: state.mfItems, total: state.mfItems.length };

		};

		const onCellClicked = async (params) => {
			if (params.event === 'group-by') {
				const existingGuids = state.mfItems?.flatMap(item => item.guids.map(x => x.guid.split("*")[1])) || [];
				if (!state.groupedElement[state.groupOrderBy.value]) {
					const gropVal = await bimplusViewer.groupByItems(state.elementData, state.groupOrderBy.value, existingGuids, state.isSDS2);
					state.groupedElement[state.groupOrderBy.value] = gropVal;
				}
				let selectedGroupedElementsColl = state.groupedElement[state.groupOrderBy.value];
				let selectedGroupedElements = [];

				for (let [key, val] of Object.entries(selectedGroupedElementsColl)) {
					let finalElements = [];
					finalElements.push(...val.filter(x => !existingGuids.includes(x.id)));
					if (!isEmpty(finalElements)) selectedGroupedElements[key] = finalElements;
				}

				let selectedElementsKeys = Object.keys(selectedGroupedElements);
				const groupedElementsObj = selectedElementsKeys.map(itemName => ({
					uuid: uuid(),
					name: itemName
				}));
				ModalProgrammatic.open({
					component: AddItemsByObjectGroup,
					props: {
						groupedItems: groupedElementsObj,
            groupingParameter: startCase(state.groupOrderBy.value)
					},
					trapFocus: true,
					canCancel: false,
					rootClass: 'modal-sm',
					events: {
    					'itemsToAdd': async (items) => {
							state.isLoading = true;
							try {
								const selectedItems = Object.entries(selectedGroupedElements)
									.filter(([key, value]) => items.some(y => y.name === key))
									.reduce((obj, [key, value]) => {
										obj[key] = value;
										return obj;
									}, {});
								await createMfItems(selectedItems);
								state.rerenderMfTable++;
							} finally {
								state.isLoading = false;
							}
						}
				    },
				})
			}
			else if (params.event === 'group-bySelection') {
				state.isViewerActive = true;
				const existingGuids = state.mfItems?.flatMap(item => item.guids.map(x => x.guid.split("*")[1])) || [];
				const elementsToSelect = bimplusViewer.getNonMfactElements(state.elementData, existingGuids);
				const filteredElements = elementsToSelect.filter(x => !['MaterialLayer', 'Opening'].includes(x.type));
				state.guidsList = filteredElements.map(x => x.id);
			}
		};

		const objGrpVal = computed(() => {
			const groupingProperty = get(state, 'selectedProject.projectSettings[0].bimplusBindings.groupingProperties[0].value', '');
			return startCase(groupingProperty);
		});

		const modelName = computed(() => {
			if (!isEmpty(get(state, 'selectedProject.projectSettings[0].bimplusSync.models'))) {
				const bimModel = find(state.selectedProject?.projectSettings[0]?.bimplusSync?.models, (model) => model.id === state.modelId);
				return bimModel?.name;
			}
			return '';
		});

		const openBIMPLUS = () => {
			return `https://portal${urls.bimplusEnvironment !== 'prod' ? '-stage' : ''}.bimplus.net/viewer/#/viewer?project_id=${get(state.selectedProject, 'projectSettings[0].bimplusSync.project.id', '')}&team_id=${get(state.selectedProject, 'projectSettings[0].bimplusSync.team.id', '')}`;
		};

		onBeforeMount(async () => {
			try {
				state.isLoading = true;
				
				state.selectedProject = await Projects.get(props.projectId);
				state.isSDS2 = get(state.selectedProject, 'projectSettings[0].bimplusSync.modelSource', '') === 'SDS2';
				state.createBOM = state.isSDS2;
				if (state.isSDS2) state.groupItemBy = itemGroupingOpts[2];

        if (!state.isSDS2) state.groupOrderBy.value = toLower(objGrpVal.value);
				
				const productionOrder = await ProductionManager.get({
					orderId: route.params.cardId,
					projectId: props.projectId,
				});
				state.order = productionOrder;
				state.order._beforeEdit = cloneDeep(productionOrder);
        state.modelId = find(state.selectedProject.projectSettings[0].bimplusSync?.models, 
          (model) => model.topologyId === route.query.topologyId)?.id ?? '';
				if(!isEmpty(state.order.modelId)) 
				{
					try {
						await BimPlus.syncGuids({
							token: store.state.bimplus.access_token,
							projectId: props.projectId,
						});
					} catch (error) {
						console.log('Error in syncing guids:', error);
					}
				}
        state.elementData = await bimplusViewer.getElementDetails(route.query.topologyId, store.state.bimplus.access_token, state.selectedProject.projectSettings[0].bimplusSync?.team?.id);
        ({ templateProject: state.templateProject } = (await Projects.haveTemplateProject()));
        state.templateOrders = (await SupplyChain.supplyChain({
          projectId: state.templateProject._id,
          module: 'MatTemplates',
          filterNoItemOrders: false,
          limit: 9999,
          page: 1,
        })).data;
			} catch (error) {
				console.log('error', error)
			} finally {
				state.isLoading = false;
			}
		});

		const headerClick = async (val) => {
			state.isViewerActive = false;
			if (val.event === 'add') {
				const keyName = '';
				const selectedItems = { [keyName]: val.selectedElements };
				await createMfItems(selectedItems);
			}

		};

		const closeAddItemsView = () => {
			router.push({
				name: `manager-edit`,
				params: {
					projectId: props.projectId,
					cardId: route.params.cardId,
					stage: 'detailing',
				},
			});
		};

		const onDeleteClicked = (rowData) => {
			remove(state.mfItems, (item) => item.uuid === rowData.data.uuid);
			state.rerenderMfTable++;
		};

		const createMfItems = async (selectedItems) => {
			for (let [key, val] of Object.entries(selectedItems)) {
				if ((state.order.items.length + state.mfItems.length) >= 50) {
					toast.warning("Item limit is 50, so we will add first 50 items");
					break;
				}

				for (let itemVal of val) {
					if ((state.order.items.length + state.mfItems.length) >= 50) break;
					const itemUUID = uuid();

					if (state.groupItemBy.value === 'group-Individual') {
						state.mfItems.push({
							name: get(itemVal, 'attributes.element.name'),
							quantity: 1,
							uuid: itemUUID,
							guids: [{
								guid: `E*${itemVal.id}`,
								quantity: 1,
								uuid: itemUUID,
								objType: itemVal.type,
							}],
							purpose: 'general',
							files: [],
              project: props.projectId,
							stage: 'detailing'
						});

          } else if(state.groupItemBy.value === 'group-Assemblies') {
            if(state.isSDS2) {
              const materials = state.elementData.filter(item => item.attributes.others["sds2 parent object"] === itemVal.attributes.others.allplanid);
              
              let materialData = [];
              for(let material of materials) {
                const setMatName = material.type === 'MechanicalFastener' ? `${material.attributes.others.bolttype}-${round(material.attributes.others.boltdiameter)}-${round(material.attributes.others.boltlength)}-${round(get(material, 'attributes.others.bolt grip length'), 2)}${material.attributes.others.tensioncontrol ? '-TC' : ''}` : '';
                const fastenerUniqueIdentifier = materialData.find((mat) => mat.identifier === setMatName);
                const uniqueIdentifier = materialData.find((mat) => mat.identifier === get(material, 'attributes.others.material piecemark', ''));

                if(!isEmpty(fastenerUniqueIdentifier)) {
                  round(fastenerUniqueIdentifier.quantity++, 4);
                  fastenerUniqueIdentifier.guids.push({
                    guid: `E*${material.id}`,
                    uuid: itemUUID,
                    parentGuid: itemVal.id
                  });

								} else if(!isEmpty(uniqueIdentifier)) {
                  round(uniqueIdentifier.quantity++, 4);
                  uniqueIdentifier.guids.push({
                    guid: `E*${material.id}`,
                    uuid: itemUUID,
                    parentGuid: itemVal.id
                  });
                } else {
                  materialData.push({
                    name: get(material, 'attributes.others.material description', setMatName),
                    quantity: 1,
                    guids: [{
                      guid: `E*${material.id}`,
                      uuid: itemUUID,
                      parentGuid: itemVal.id
                    }],
                    identifier: get(material, 'attributes.others.material piecemark', setMatName),
                    project: props.projectId,
                    createdFrom: "SDS2",
                    category: get(material, 'attributes.others.material type', ''),
                    subCategory: get(material, 'attributes.others.steelgrade', ''),
                  });
                }
              }
              const sameItem = state.groupOrderBy.value === 'name' ?
              state.mfItems.find((item) => item.name === get(itemVal, 'attributes.element.name', '')) :
              state.mfItems.find((item) => item.identifier === (isNumber(get(itemVal, 'attributes.others.piecemark', '')) ? round(get(itemVal, 'attributes.others.piecemark', ''), 3) : get(itemVal, 'attributes.others.piecemark', '')));
              if(!isEmpty(sameItem)) {
                round(sameItem.quantity++, 4);
                sameItem.guids.push({
                  guid: `A*${itemVal.id}`,
                  quantity: 1,
                  uuid: sameItem.uuid,
                  objType: itemVal.type,
                })

                for(let matData of materialData) {
                  for(let existingItem of sameItem.materials) {
                    if(matData.identifier === existingItem.identifier) {
                      existingItem.quantity = matData.quantity + existingItem.quantity;
                      existingItem.guids.push(...matData.guids);
                    }
                  }
                }
              }
              else {
                state.mfItems.push ( {
                  name: state.groupOrderBy.value === 'name' ? key : `${get(itemVal, 'attributes.others.member description', '')}-${get(itemVal, 'attributes.others.piecemark', '')}`,
                  quantity: 1,
                  uuid: itemUUID,
                  guids: [{
                    guid: `A*${itemVal.id}`,
                    quantity: 1,
                    uuid: itemUUID,
                    objType: itemVal.type,
                  }],
                  purpose: 'assembly',
                  files: [],
                  materials: materialData,
                  identifier: isNumber(get(itemVal, 'attributes.others.piecemark', '')) ? round(get(itemVal, 'attributes.others.piecemark', ''), 3) : get(itemVal, 'attributes.others.piecemark', ''),
                  project: props.projectId,
                  createdFrom: "SDS2",
                  category: get(itemVal, 'attributes.others.member type', ''),
                  subCategory: '',
                  stage: 'detailing'
                });
              }        
            } else {
              state.mfItems.push ( {
                name: '(Non-Assembly)',
                quantity: 1,
                uuid: itemUUID,
                guids: [{
                  guid: `E*${itemVal.id}`,
                  quantity: 1,
                  uuid: itemUUID,
                  objType: itemVal.type,
                }],
                purpose: 'assembly',
                project: props.projectId,
                files: [],
                stage: 'detailing'
              });
            }    
          } else if(state.groupItemBy.value === 'group-single') {
            const existingItem = state.mfItems.find((item) => item.name === key);
            if(existingItem) {
              existingItem.guids.push({
                guid: `E*${itemVal.id}`,
                quantity: 1,
                uuid: existingItem.uuid,
                objType: itemVal.type,
              });
            } else {
              state.mfItems.push ( {
                name: key,
                quantity: 1,
                uuid: itemUUID,
                guids: [{
                  guid: `E*${itemVal.id}`,
                  quantity: 1,
                  uuid: itemUUID,
                  objType: itemVal.type,
                }],
                files: [],
                project: props.projectId,
                purpose: 'general',
                stage: 'detailing'
              });
            }
          }
        }  
      }
      for (let item of state.mfItems) {
				if (!isEmpty(item.identifier)) state.identifierList.push(toUpper(item.identifier));
				if (!isEmpty(item.materials)) {
					for (let mat of item.materials) {
						if (!isEmpty(mat.identifier)) state.identifierList.push(toUpper(mat.identifier));
					}
				}
				if(state.isSDS2) await addBimplusDocs(item);
			}
    };

    const isolateModel = async (selectedRow, frmGuidLvl = false) => {
      if(!frmGuidLvl) {
        state.guidsList = selectedRow.guids?.map(x => x.guid.split('*')[1]);
        if(!isEmpty(selectedRow.materials)) {
          const materialGuids = selectedRow.materials
              .flatMap(x => x.guids)
              .map(y => y.guid.split('*')[1]);
          state.guidsList.push(...materialGuids);
        }
      } else {
        state.guidsList.push(selectedRow.guid.split('*')[1]);    
      }
      state.isViewerActive = true;
      state.enableIsolateView = true;
      state.enableAddObjectsBySelection = false;
      state.disableObjectProperties = false;
    };

    const closeViewer = () => {
      state.isViewerActive = false;
      state.enableIsolateView = false;
      state.enableAddObjectsBySelection = true;
      state.disableObjectProperties = true;
      state.guidsList = [];
    };

    const addDocs = async (selectedRowData) => {
      try {
        if(state.isSDS2 && !selectedRowData.isBimDocsAdded) {
          const teamSlug = state.selectedProject.projectSettings[0].bimplusSync?.team?.id;
          const files = await bimplusViewer.getElementAttachments((selectedRowData.guids[0].guid.split('*'))[1], teamSlug);
          if(!isEmpty(files)) {
            for(const file of files) {
              const fileObj = {
                "archived": {
                    "value": false
                },
                "url": `${teamSlug}/attachments/${file.id}`, // pdf id or ncl id
                "name": file.fileName,
                "isPrivate": true,
                "type": "bimPlus",
                "visible": "to-me",
              }
              selectedRowData.files.push(fileObj);
            }
          }
          selectedRowData.isBimDocsAdded = true;
        }
        state.docsEdit = true;
        state.selectedRowData = selectedRowData;
        state.docsTitle = 'Item';
      } catch (error) {
        console.log('Error:', error);
      }
      
    };

    const closeDocsModal = () => {
      state.docsEdit = !state.docsEdit;
			state.selectedRowData = {}
    };

    const applyTemplate = (selectedRowData, event) => {
			const { value: template } = event;
      selectedRowData.templateId = template?._id;
      selectedRowData.templateName = template?.name;
      selectedRowData.template = template;
    };

    emitter.on('isolateFromGuidLvl', async (rowData) => {
      await isolateModel(rowData, true);
    });
   
		const addItems = async () => {
			state.isLoading = true;
			const assemblyParts = await Catalogs.getAssemblyParts({
				catId: uniq(state.identifierList),
				type: 'assemblyAndItems',
				filteredProjects: [props.projectId],
				showAssmbsParts: true,
			});

			state.mfItems.forEach((item) => {
				if (state.isSDS2) {
					let catalogAssembly = find(assemblyParts.data, (catalog) => toUpper(catalog.identifier) === toUpper(item.identifier));
					if(!isEmpty(catalogAssembly)) item.catId = catalogAssembly.catId;
					if (!isEmpty(item.materials)) {
						item.materials.map((mat) => {
							let catalogPart = find(assemblyParts.data, (catalog) => toUpper(catalog.identifier) === toUpper(mat.identifier));
							if(!isEmpty(catalogPart)) mat.catId = catalogPart.catId;
						})
					}
				}
				item = _.pick(item, ['catId', 'customId', 'measureUnits', 'name', 'identifier', 'files']);
				item.isEditing = true;
				item.purpose = state.order.purpose === 'kit' ? 'assembly' : 'general';
				item.cards = [state.order.items[0].prefab._id, state.order._id];
				item.prefab = { _id: state.order.items[0].prefab._id };
				state.order.files.push(...item.files);
				let index = addPMItem(state.order, item);
				for (const doc of item?.files) {
					const boItem = state.order.items[index];
					const file = boItem.newFile();
					Object.assign(file, doc);
				}
				state.order.items[index].newFTD('memos');
			});
			state.isLoading = false;
		};

		const reloadPage = async (opts) => {
			state.rerenderMfTable++;
			store.commit('setreOrderRunsName', []);
		};

		const addBimplusDocs = async (item) => {
			const teamSlug = state.selectedProject.projectSettings[0].bimplusSync?.team?.id;
			const files = await bimplusViewer.getElementAttachments((item.guids[0].guid.split('*'))[1], teamSlug);
			if(!isEmpty(files)) {
				for(const file of files) {
					const fileObj = {
						"archived": {
							"value": false
						},
						"url": `${teamSlug}/attachments/${file.id}`, // pdf id or ncl id
						"name": file.fileName,
						"isPrivate": true,
						"type": "bimPlus",
						"visible": "to-me",
					}
					item.files.push(fileObj);
				}
				item.isBimDocsAdded = true;
			}
		};

		return {
			...toRefs(state),
			openBIMPLUS,
			modelName,
			objGrpVal,
			loadItemsData,
			BIMPLUSItemTable,
			onCellClicked,
      objectGroupingOpts,
      itemGroupingOpts,
      headerClick,
      closeAddItemsView,
      onDeleteClicked,
      isolateModel,
      closeViewer,
      addDocs,
      closeDocsModal,
      applyTemplate,
			addItems,
			saveCard,
			reloadPage
		}
	}
}
</script>